import store from "../../redux/store";
import { boundSetSwitchPurposes, boundSetSwitchCustoms } from "../../redux/actions/switches";

const setSwitchesData = () => {
    const state = store.getState();
    const list = state.vendorList.list;
    const customList = state.customPurposesList.list;
    const purposesList = list.purposes;
    
    const purposes = state.consent.purposes;

    // not yet in use
    // const vendors = state.consent.vendors;
    // const features = state.consent.features;
    // const vendorList = list.vendors;
    // const featuresList = list.features;

    const purposesSwitches = purposesList.map(e => ({
        id: e.id,
        isOn: (purposes.indexOf(e.id) >= 0),
    }));

    // custom switches are by default disabled and turned ON
    const customSwitches = customList.purposes.map(e => ({
        id: e.id,
        isOn: true,
        disabled: true,
    }));

    boundSetSwitchPurposes(purposesSwitches);
    boundSetSwitchCustoms(customSwitches);
    
    // set vendor switches
    // set feature switches
}

export default setSwitchesData;